//LoginRoutes.js

import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "../pages/auth/Login";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ResetPassword from "../pages/auth/ResetPassword";
import VerifyOtp from "../pages/auth/VerifyOtp";
import SignupMobile from "../pages/auth/signup/SignupMobile";
import SignupOtp from "../pages/auth/signup/SignupOtp";
import SignupAadhaar from "../pages/auth/signup/SignupAadhaar";
import SignupAadhaarOtp from "../pages/auth/signup/SignupAadhaarOtp";
import SignupAadhaarUpload from "../pages/auth/signup/SignupAadhaarUpload";
import SignupPan from "../pages/auth/signup/SignupPan";
import SignupPanUpload from "../pages/auth/signup/SignupPanUpload";
import SignupBusinessDetails from "../pages/auth/signup/SignupBusinessDetails";
import SignupBusinessDocuments from "../pages/auth/signup/SignupBusinessDocuments";
import SignupSuccess from "../pages/auth/signup/SignupSuccess";


const LoginRoutes = () => {
    return (
        <>
            <Routes>
                <Route
                    path="/"
                    element={
                        <Login />
                    }
                />
                <Route
                    path="/forgot-password"
                    element={
                        <ForgotPassword />
                    }
                />
                <Route
                    path="/reset-password"
                    element={
                        <ResetPassword />
                    }
                />
                <Route
                    path="/verify-otp"
                    element={
                        <VerifyOtp />
                    }
                />
                <Route
                    path="/signup"
                    element={
                        <SignupMobile />
                    }
                />
                <Route
                    path="/signup/otp"
                    element={
                        <SignupOtp />
                    }
                />
                <Route
                    path="/signup/aadhaar"
                    element={
                        <SignupAadhaar />
                    }
                />
                <Route
                    path="/signup/aadhaar-otp"
                    element={
                        <SignupAadhaarOtp />
                    }
                />
                <Route
                    path="/signup/aadhaar-upload"
                    element={
                        <SignupAadhaarUpload />
                    }
                />
                <Route
                    path="/signup/pan"
                    element={
                        <SignupPan />
                    }
                />
                <Route
                    path="/signup/pan-upload"
                    element={
                        <SignupPanUpload />
                    }
                />
                <Route
                    path="/signup/business-details"
                    element={
                        <SignupBusinessDetails />
                    }
                />
                <Route
                    path="/signup/business-documents"
                    element={
                        <SignupBusinessDocuments />
                    }
                />
                <Route
                    path="/signup/success"
                    element={
                        <SignupSuccess />
                    }
                />
            </Routes>
        </>

    );
};

export default LoginRoutes;